// libs
import React from 'react'

// components
import ItemGroupHeader from 'src/components/item_group_header/item_group_header'
import LoadingSpinnerWrapper from 'src/components/loading_spinner/loading_spinner_wrapper'
import { CustomRenderProfileList } from 'src/components/profiles_list/profiles_list'
import ProfileItem from 'src/containers/smart_components/group_member_list/profile_item'
import ProfileListWrapper from 'src/containers/smart_components/list_wrapper/profile_list_wrapper'

// helper
import {
  GroupDetailFragmentFragment,
  GroupParticipationFragmentFragment
} from '@lopo-tech/lopo-api'
import { textResources } from 'src/lang/de'

interface IProps {
  currentPage: number;
  loading: boolean;
  group: GroupDetailFragmentFragment | null;
  getNextPage: () => void;
}

const renderItem = (participation: GroupParticipationFragmentFragment) => (
  <ProfileItem key={participation.id} participation={participation} />
)

const keyExtractor = (participation: GroupParticipationFragmentFragment) =>
  participation.id

const GroupMembersList: React.FC<IProps> = ({
  currentPage,
  loading,
  group,
  getNextPage
}) => {
  const groupParticipations = group?.groupParticipations?.items
  const pendingParticipations = group?.pendingGroupParticipations?.items

  return (
    <LoadingSpinnerWrapper isLoading={loading}>
      <ProfileListWrapper getNextPage={getNextPage} currentPage={currentPage}>
        <>
          {pendingParticipations && !!pendingParticipations.length && (
            <>
              <ItemGroupHeader title={textResources.groups.pendingUsers} />
              <CustomRenderProfileList
                items={pendingParticipations}
                keyExtractor={keyExtractor}
                renderItem={renderItem}
              />
            </>
          )}
          {groupParticipations && !!groupParticipations.length && (
            <>
              <ItemGroupHeader title={textResources.groups.confirmedUsers} />
              <CustomRenderProfileList
                items={groupParticipations}
                keyExtractor={keyExtractor}
                renderItem={renderItem}
              />
            </>
          )}
        </>
      </ProfileListWrapper>
    </LoadingSpinnerWrapper>
  )
}

export default GroupMembersList
